import {defineSlotRecipe} from '@chakra-ui/react3'

export const comparisonTableRecipe = defineSlotRecipe({
    slots: [
        'moduleContainer',
        'heading',
        'table',
        'column',
        'select',
        'image',
        'swatch',
        'element'
    ],
    base: {
        moduleContainer: {
            overflow: 'hidden',
            position: 'relative'
        },
        heading: {
            paddingBottom: {base: 'spacing-40', s: 'spacing-128'},
            maxWidth: '38.75rem',
            ml: 'auto',
            mr: 'auto'
        },
        table: {
            width: '100%',
            borderCollapse: 'separate',
            borderSpacing: '{spacing.spacing-16} 0'
        },
        column: {
            paddingTop: {base: 'spacing-16', s: 'spacing-32'},
            paddingBottom: 'spacing-32',
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-8',
            backgroundColor: 'var(--module-surface-bg-color)'
        },
        select: {
            px: {base: 'spacing-16', s: 'spacing-24'},
            paddingBottom: 'spacing-8',
            paddingTop: {base: 'spacing-16', s: 'spacing-32'},
            backgroundColor: 'var(--module-surface-bg-color)',
            display: 'flex',
            justifyContent: 'center',
            color: 'fg'
        },
        image: {
            aspectRatio: 4 / 3,
            width: '100%',
            paddingBottom: 'spacing-8',
            backgroundColor: 'var(--module-surface-bg-color)'
        },
        swatch: {
            position: 'relative',
            aspectRatio: '1/1',
            borderRadius: 'round',
            boxSize: '1rem',
            overflow: 'hidden',
            '&:not(:first-of-type)': {
                marginLeft: '-0.25rem'
            },
            _after: {
                content: '""',
                position: 'absolute',
                inset: 0,
                borderRadius: 'round',
                boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.24) inset'
            },
            _groupActive: {
                outlineColor: 'border.brand',
                outlineStyle: 'solid',
                outlineWidth: '1px',
                outlineOffset: '2px'
            }
        },
        element: {
            px: {base: 'spacing-16', s: 'spacing-24'},
            py: 'spacing-16',
            textAlign: 'center',
            _icon: {
                width: '6',
                height: '6'
            },
            color: 'text.secondary',
            justifyContent: 'center',
            alignItems: 'baseline',
            backgroundColor: 'var(--module-surface-bg-color)'
        }
    }
})
